import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Drop List Component
 * @param {StyledProps} props - width, itemList, value, onChange, defaultValue, disabled, backgroundColor, listWidth, placeholder, maxLength
 * @example
 * <DropList
 * 	width="100px"
 * 	itemList={new Map([ ['Midas', 1], ['Civil', 2], ['Gen', 3], ['CIM', 4] ])}
 * 	onChange={() => {}}
 * 	value={1}
 * 	defaultValue={1}
 * 	disabled={false || true}
 * 	backgroundColor="white"
 * 	listWidth="100px"
 * 	placeholder="placeholder"
 * 	maxLength={10}
 * />
 * @returns {React.ReactElement} MoaDropList
 */
var DropList = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
DropList.defaultProps = {
    itemList: new Map(),
    value: "",
    onChange: function () { },
    defaultValue: ""
};
var SampleProps = {
    width: '100px',
    itemList: new Map([['Midas', 1], ['Civil', 2], ['Gen', 3], ['CIM', 4]]),
    onChange: function () { },
    value: 1,
    defaultValue: 1,
    disabled: false,
    backgroundColor: "white",
    listWidth: '100px',
    placeholder: "placeholder",
    maxLength: 10,
};
export default DropList;
export { SampleProps as DropListSample, };
